export const customizableTitles = {
    compensation_step_title: 'Compensation',
    select_products_step_title: 'Products',
    tasks_step_title: 'Tasks',
    other_info_step_title: 'Other Information',
    assets_step_title: 'Brand Assets',
    content_rights_step_title: 'Content Rights',
    campaign_proposal_dates_header: 'Submit Proposal By',
    campaign_content_dates_header: 'Deliver Content By',
    get_started_button_text: 'Get Started',
    proposal_submitted_header: 'Your proposal was submitted.'
};
export const staticTitles = {
    'social-networks': 'Social Networks',
    'shipping-info': 'Shipping Information'
};
